module.exports = __webpack_public_path__ + "static/media/thumbnail.89aa463e.jpg";